import { NavLink } from 'react-router';

const LINKS = [
  { to: '/groups', label: 'Revisión', end: true },
  { to: '/groups/new', label: 'Crear grupo', end: false },
  { to: '/groups/flagged', label: 'Marcados', end: false },
];

// Secondary nav for the product-grouping admin pages. Lives under the shared
// Header (which already gates on the signed-in allowlist).
export function GroupsNav() {
  return (
    <nav
      aria-label="Agrupación de productos"
      className="flex items-center gap-1 px-6 border-b border-border-subtle bg-bg-card"
    >
      {LINKS.map((l) => (
        <NavLink
          key={l.to}
          to={l.to}
          end={l.end}
          className={({ isActive }) =>
            `px-3 py-2 text-sm border-b-2 -mb-px ${
              isActive
                ? 'border-orange-500 text-text-primary font-medium'
                : 'border-transparent text-text-secondary hover:text-text-primary'
            }`
          }
        >
          {l.label}
        </NavLink>
      ))}
    </nav>
  );
}
